import React, { useState } from "react";
import QuestionHeader from '../Signup/components/QuestionHeader';
import InsertPhoneNumber from './components/InsertPhoneNumber';
import { smsAuthentication } from '../../services/accountService';
import Verify from './components/Verify';
import { useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import StepperPage from "../../components/stepper/StepperPage";
import NiceModal from "@ebay/nice-modal-react";

type SmsVerificationContainerProps = {
    isFromNeedToVerifyProfile?: boolean;
}

export function SmsVerificationContainer(props: SmsVerificationContainerProps) {
    const member = useSelector((state: RootState) => state.member);
    const history = useHistory();
    const [verifyCode, setVerifyCode] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");


    const showInfoModal = () => {
        NiceModal.show("action_modal", {
            onNext: () => NiceModal.hide("action_modal"),
            headerTitle: "אימות טלפון",
            contentTitle: "הודעת sms נשלחה שוב",
            seconderyButtonText: "",
            primaryButtonText: "אישור",
            showCloseButton: true,
            showSeconderyButton: false
        });
    }

    const getVerifyCode = async (phoneNumber: string) => {
        //api called;
        try {
            const { data } = await smsAuthentication({ memberCode: member.memberCode, phoneNumber: phoneNumber });
            setVerifyCode(data);
            return data;
        } catch (err) {
            console.dir(err)
            return err
        }
    };

    const stepComponents = [
        {
            component: InsertPhoneNumber,
            props: { getVerifyCode, phoneNumber, setPhoneNumber },
            title: "InsertPhoneNumber"
        },
        {
            component: Verify,
            props: { code: verifyCode, phoneNumber, setPhoneNumber, getVerifyCode, isFromNeedToVerifyProfile: props.isFromNeedToVerifyProfile, showInfoModal },
            title: "Verify"
        },
    ]

    const navigateBack = () => {
        history.goBack();
    };


    return (
        <div>
            <StepperPage
                containStepperHeader={true}
                components={stepComponents}
                handleBackBrowserButton={false}
                hasBackButton={true}
                onClose={navigateBack}
                isFromNeedToVerifyProfile={props.isFromNeedToVerifyProfile}
            />
        </div>
    )
}